module.exports = __webpack_public_path__ + "static/img/loginBG_A6405.e551cbd4.png";